module.exports = __webpack_public_path__ + "static/media/mindy_waving_admin.278d4ae3.png";